class APP_Map {
  constructor(id = 0, map_element) {
    this.id = id;

    // HTML Elements
    this.map_elem = map_element;
    this.block_elem = map_element.closest(".app-map");
    this.marker_elems = [];
    this.info_windows = [];

    this.user_location = null;

    // Set the ID on the parent element
    this.block_elem.dataset.id = this.id;

    // Add valid markers to the marker_elems array
    this.map_elem.querySelectorAll(".marker").forEach((marker_elem) => {
      if (marker_elem.dataset.lat && marker_elem.dataset.lng) {
        this.marker_elems.push(marker_elem);
      }
    });

    if (typeof google === "undefined") {
      console.error("APP Map Failure", "Google Maps API not loaded.");
      this.block_elem.classList.add("_hidden");
      return;
    }

    // Create the Google Map
    this.map = new google.maps.Map(this.map_elem, {
      backgroundColor: "#008cd1",
      styles: this.get_styles(),
      disableDefaultUI: true,
      zoomControl: true,
    });

    this.add_markers();

    // Center the map and zoom
    this.map.setCenter(
      new google.maps.LatLng(28.441200828666247, 53.89027359999998)
    );
    this.map.setZoom(2);
  }

  add_markers() {
    this.map.markers = [];

    this.marker_elems.forEach((marker_elem) => {
      if (!marker_elem.dataset.lat || !marker_elem.dataset.lng) {
        return;
      }

      const svgMarker = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: "#FADE00",
        fillOpacity: 1,
        strokeWeight: 1,
        strokeColor: "#005b65",
        rotation: 0,
        scale: 8,
      };

      if (marker_elem.dataset.status == "inactive") {
        svgMarker.fillColor = "#BEBFC0";
      }

      let marker = new google.maps.Marker({
          position: new google.maps.LatLng(
            parseFloat(marker_elem.dataset.lat),
            parseFloat(marker_elem.dataset.lng)
          ),
          icon: svgMarker,
          map: this.map,
          id: parseInt(marker_elem.dataset.id),
          title: marker_elem.dataset.title,
          country: marker_elem.dataset.country,
          status: marker_elem.dataset.status,
        }),
        info_window = null;

      // Info Window
      if (marker_elem.innerHTML) {
        info_window = new google.maps.InfoWindow({
          content: marker_elem.innerHTML,
          id: parseInt(marker_elem.dataset.id),
        });

        this.info_windows.push(info_window);
      }

      // Events
      google.maps.event.addListener(marker, "click", () => {
        this.close_windows();
        this.map.panTo(marker.getPosition());

        if (info_window) {
          info_window.open(this.map, marker);
        }
      });

      this.map.markers.push(marker);
    });
  }

  close_windows() {
    this.info_windows.forEach((info_window) => {
      info_window.close();
    });
  }

  /**
   * Finds the marker with the given ID, and pans to it.
   * @param {number} marker_id The marker ID.
   */
  goto_marker(marker_id) {
    this.close_windows();

    this.map.markers.forEach((marker) => {
      if (marker.id == marker_id) {
        this.map.panTo(marker.getPosition());
        this.map.setZoom(6);

        this.info_windows.forEach((info_window) => {
          if (info_window.id == marker_id) {
            info_window.open(this.map, marker);
          }
        });
      }
    });
  }

  filter(search_term = "", country_name = [], status = []) {
    const bounds = new google.maps.LatLngBounds(),
      markers = [...this.map.markers],
      filtered_markers = [];

    // Filter by search term
    if (search_term) {
      markers.forEach((marker) => {
        if (marker.title.toLowerCase().includes(search_term.toLowerCase())) {
          filtered_markers.push(marker);
        }
      });
    } else {
      filtered_markers.push(...markers);
    }

    filtered_markers.forEach((marker) => {
      marker.passing = true;
    });

    // Filter by country
    if (country_name.length > 0) {
      filtered_markers.forEach((marker) => {
        if (!country_name.includes(marker.country)) {
          marker.passing = false;
        }
      });
    }

    // Filter by status
    if (status.length > 0) {
      filtered_markers.forEach((marker) => {
        if (!status.includes(marker.status)) {
          marker.passing = false;
        }
      });
    }

    let final_markers = filtered_markers.filter((marker) => {
      return marker.passing == true;
    });

    this.close_windows();

    // Hide all list items and show those that pass filters
    this.block_elem.querySelectorAll(".app-map__list-item").forEach((list_elem) => {
        list_elem.classList.add("_hidden");

        if (list_elem.dataset.id) {
          let found = false;

          final_markers.forEach((marker) => {
            if (marker.id == list_elem.dataset.id) {
              found = true;
            }
          });

          if (found) {
            list_elem.classList.remove("_hidden");
          }
        }
    });

    // Hide all map markers and show those that pass filters
    this.map.markers.forEach((marker) => {
      marker.setVisible(false);

      final_markers.forEach((final_marker) => {
        if (marker.id == final_marker.id) {
          marker.setVisible(true);
        }
      });
    });

    if (final_markers.length == 1) {
      document.querySelector(".app-map__list-count").innerHTML = `${final_markers.length} Chapter`;
    } else {
      document.querySelector(".app-map__list-count").innerHTML = `${final_markers.length} Chapters`;
    }

    // If no markers pass filters, don't adjust zoom or center
    if (final_markers.length == 0) {
      return;
    }

    // Extend the bounds of the markers we've found
    final_markers.forEach((marker) => {
      bounds.extend(marker.position);
    });

    if (final_markers.length > 1) {
      this.map.fitBounds(bounds);

      if (this.map.getZoom() > 5) {
        this.map.setZoom(5);
      }
    } else if (final_markers.length == 1) {
      this.goto_marker(final_markers[0].id);
    }

    // Do not allow zoom to drop beneath 3
    if (this.map.getZoom() < 3) {
      this.map.setZoom(3);
    }
  }

  /**
   * Geolocates the user and places a pin on the map. Once complete, it orders the markers by distance from the user.
   */
  get_user_location() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {   
          this.user_location = position;
             
          var marker = new google.maps.Marker({
              position: new google.maps.LatLng(position.coords.latitude, position.coords.longitude),
              map: this.map,
          });
      
          this.map.markers.push(marker);
          this.map.setZoom(4);
          this.map.panTo(marker.getPosition());

          this.order_by_distance(position.coords.latitude, position.coords.longitude);
        });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  order_by_distance(lat, lng) {
    let list = this.block_elem.querySelector(".app-map__list-scroll"),
        list_items = this.block_elem.querySelectorAll(".app-map__list-item");

    list_items.forEach(list_item => {
        if (!list_item.dataset) {
            return;
        }

        if (!list_item.dataset.lat || !list_item.dataset.lng) {
            return;
        }
        
        let distance_amount = this.compute_distance(lat, lng, parseFloat(list_item.dataset.lat), parseFloat(list_item.dataset.lng));
        list_item.dataset.distance = distance_amount;

        let miles_indicator = document.createElement('span');
        miles_indicator.classList.add('app-map__miles-indicator');
        miles_indicator.innerText = `≈${distance_amount} miles away`;

        if (distance_amount < 100) {
            miles_indicator.classList.add('-gold');
        }

        list_item.appendChild(miles_indicator);
    });

    let sorted_list_items = Array.from(list_items).sort((a, b) => {
        return parseFloat(a.dataset.distance) - parseFloat(b.dataset.distance);
    });

    list.innerHTML = '';

    sorted_list_items.forEach(list_item => {
        list.appendChild(list_item);
    });

    list.scrollTop = 0;
  }

  compute_distance(lat1, lon1, lat2, lon2) {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;

    if (dist >= 1) {
      return Math.ceil(dist);
    }

    return dist.toFixed(2);
  }


  /**
   * Returns the styles for the Google map in a JSON format.
   * @returns {Array} An array of styles for the Google Map.
   */
  get_styles() {
    return [
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#3ab1ae" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#198380" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
          elementType: "labels.text.stroke",
          stylers: [
              {
                  "color": "#acdbdf"
              }
          ]
      },
      {
          elementType: "labels.text.fill",
          stylers: [
              {
                  "color": "#003e45"
              }
          ]
      },
      {
        featureType: "administrative.country",
        elementType: "geometry.stroke",
        stylers: [{ color: "#005b65" }],
      },
      {
        featureType: "administrative.country",
        elementType: "labels",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [{ color: "#3ab1ae" }],
      },
      {
        featureType: "landscape",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi.school",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi.sports_complex",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway.controlled_access",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway.controlled_access",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit.line",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit.station",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [{ color: "#008cd1" }],
      },
      {
        featureType: "water",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
    ];
  }
}

export default APP_Map;
